<template>
  <div class="order-form card p-3 modal-full-height">
    <h4>{{ isEdit ? lang.bsof_edit_order : lang.bsof_create_order }}</h4>

    <form @submit.prevent="onSave">
      <div class="row">
        <div class="col-6">
          <label>{{ lang.bsof_first_name }}</label>
          <input v-model="order.customer_name" class="form-control" :placeholder="lang.bsof_first_name_ph"/>
        </div>
        <div class="col-6">
          <label>{{ lang.bsof_last_name }}</label>
          <input v-model="order.customer_lastname" class="form-control" :placeholder="lang.bsof_last_name_ph"/>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-4">
          <label>{{ lang.bs_phone }}</label>
          <input v-model="order.customer_phone" class="form-control" :placeholder="lang.bsof_phone_ph"/>
        </div>
        <div class="col-4">
          <label>{{ lang.bs_email }}</label>
          <input v-model="order.customer_email" class="form-control" :placeholder="lang.bsof_email_ph"/>
        </div>
        <div class="col-4">
          <label>{{ lang.bsof_order_source }}</label>
          <select v-model="order.order_source" class="form-control">
            <option value="cart">{{ lang.bsof_source_cart }}</option>
            <option value="manual">{{ lang.bsof_source_manual }}</option>
            <option value="whatsapp">{{ lang.bsof_source_whatsapp }}</option>
          </select>
        </div>
      </div>

      <hr style="margin: 0.2rem 0 0.5rem 0; width: 100%;"/>

      <OrderItemsTableV2 :items="order.items" :productosGrouped="productosGrouped" :taxesPercent="taxesPercent" :proptaxShow="tax_enabled" @update-items="onItemsUpdate" />

      <div class="row mt-3">
        <div class="col-7">
          <label>{{ lang.bs_notes }}</label>
          <tbDescription v-model="order.notes" :limit="500" limit-type="words" :placeholder="lang.bsof_notes_ph" editor-class="order-notes-editor" />
        </div>
        <div class="col-5">
          <div class="row">
            <div class="col-4 mt-2"><label>{{ lang.bs_subtotal }}</label></div>
            <div class="col-8">
              <div class="form-control-plaintext text-right">$ {{ subtotal | formatMoney }}</div>
            </div>
            <div class="col-4 mt-2"><label>{{ lang.bsof_discount_label }}</label></div>
            <div class="col-8 d-flex align-items-center justify-content-end">
              <input type="number" step="1" min="0" max="99" v-model.number="order.discount_total" class="form-control text-right" style="max-width: 100px;" />
            </div>
            <div class="col-4 mt-2" v-if="tax_enabled"><label>{{ lang.bs_tax }} ({{this.setting.tax_percent}}%)</label></div>
            <div v-if="tax_enabled" class="col-8 d-flex align-items-center justify-content-end">
              $ {{ total_tax | formatMoney }}
            </div>
            <div class="col-4 mt-2" v-if="delivery_fee > 0"><label>{{ lang.bs_delivery_fee }}</label></div>
            <div v-if="delivery_fee > 0" class="col-8 d-flex align-items-center justify-content-end">
              $ {{ delivery_fee | formatMoney }}
            </div>
          </div>
        </div>
      </div>
      <!-- Fixed footer with buttons left and total right -->
      <div class="order-form-footer">
        <div class="footer-left">
          <button class="btn btn-primary" type="submit">{{ lang.bs_save }}</button>
          <button class="btn btn-secondary" type="button" @click.prevent="$emit('cancel')">{{ lang.bs_cancel }}</button>
        </div>
        <div class="footer-right">
          <div class="footer-total-label">{{ lang.bs_total }}</div>
          <div class="footer-total-amount">${{ total | formatMoney }}</div>
        </div>
      </div>
    </form>
  </div>

</template>

<script>
import { mapGetters } from "vuex";
import OrderItemsTableV2 from './OrderItemsTable.v2.vue';
import tbDescription from '@/apps/billing/components/RichTextEditor.vue';
import './orderForm.scss';
function normalizeItem(item) {
  return {
    id: item.id || null,
    product_id: item.product_id || null,
    product_name: item.product_name || '',
    price: Number(item.price) || 0,
    quantity: Number(item.quantity) || 0,
    taxOpc: (item.taxOpc === null || typeof item.taxOpc === 'undefined') ? null : Number(item.taxOpc),
    total: Number((Number(item.price) * Number(item.quantity)).toFixed(2)),
    note_item: item.note_item || '',
  };
}
export default {
  name: 'OrderForm',
  components: { OrderItemsTableV2, tbDescription },
  props: {
    orderData: { type: Object, default: null },
    productosGrouped: { type: Array, default: () => [] },
    setting: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      lang: {
        bsof_edit_order: '',
        bsof_create_order: '',
        bsof_first_name: '',
        bsof_first_name_ph: '',
        bsof_last_name: '',
        bsof_last_name_ph: '',
        bs_phone: '',
        bsof_phone_ph: '',
        bs_email: '',
        bsof_email_ph: '',
        bsof_order_source: '',
        bsof_source_cart: '',
        bsof_source_manual: '',
        bsof_source_whatsapp: '',
        bs_notes: '',
        bsof_notes_ph: '',
        bs_subtotal: '',
        bsof_discount_label: '',
        bs_tax: '',
        bs_delivery_fee: '',
        bs_save: '',
        bs_cancel: '',
        bs_total: '',
      },
      isEdit: Boolean(this.orderData),
      order: {
        customer_name: this.orderData ? this.orderData.customer_name : '',
        customer_lastname: this.orderData ? this.orderData.customer_lastname : '',
        customer_phone: this.orderData ? this.orderData.customer_phone : '',
        customer_email: this.orderData ? this.orderData.customer_email : '',
        order_source: this.orderData ? this.orderData.order_source : 'web',
        discount_total: this.orderData ? this.orderData.discount_total : 0,
        notes: this.orderData ? this.orderData.notes : '',
        items: (this.orderData && Array.isArray(this.orderData.order_items)) ? this.orderData.order_items.map(i => normalizeItem(i)) : [],
      },
      subtotal: 0,
      total: 0,
      taxesPercent: this.setting.tax_enabled && this.setting.tax_percent > 0 ? this.setting.tax_percent : 0,
      tax_enabled: this.setting.tax_enabled || false,
      delivery_fee: this.setting.delivery_enabled && this.setting.delivery_fee > 0 ? this.setting.delivery_fee : 0
    };
  },
  mounted() {
    this.lang = this.$store.getters['ModApps/Marketea/lang'];
    if(this.orderData && this.orderData.id){
      this.order.id = this.orderData.id; // ensure ID is included for edits
    }
    this.calculateTotals();
  },
  computed: {
    ...mapGetters("ModApps/Marketea", {
      langGetter: "lang",
    }),
    total_tax() {
      return ((this.subtotal * this.taxesPercent) / 100);
    }
  },
  methods: {
    onItemsUpdate(items) {
      // replace items and recalc totals
      this.order.items = (items || []).map(i => ({ ...i }));
      this.calculateTotals();
    },
    onSave() {
      this.calculateTotals();
      this.$emit('save', JSON.parse(JSON.stringify(this.order)));
    },
    calculateTotals() {
      const items = this.order.items || [];
      // normalize item fields and compute raw totals
      items.forEach(it => {
        it.price = Number(it.price) || 0;
        it.quantity = Number(it.quantity) || 0;
        // keep taxOpc as provided (could be 0 or a specific percent)
        it.taxOpc = (it.taxOpc === null || typeof it.taxOpc === 'undefined') ? null : Number(it.taxOpc);
        it.total = Number((it.price * it.quantity).toFixed(2));
      });

      // subtotal is sum of item totals (before discount)
      this.subtotal = Number((items.reduce((s, it) => s + Number(it.total || 0), 0)).toFixed(2));

      const discountPercent = Number(this.order.discount_total) || 0;
      const clampedPercent = Math.max(0, Math.min(100, discountPercent));
      // total discount amount applied to subtotal
      const discountAmount = Number((this.subtotal * clampedPercent / 100).toFixed(2));

      // compute per-item discount and per-item tax based on each item's taxOpc (fallback to global taxesPercent)
      let accumulatedTax = 0;
      items.forEach(it => {
        const itemDiscount = Number(((it.total || 0) * clampedPercent / 100).toFixed(2));
        const taxPercent = (it.taxOpc !== null && typeof it.taxOpc !== 'undefined' && it.taxOpc !== '')
          ? Number(it.taxOpc)
          : this.taxesPercent || 0;

        const taxableBase = Number((it.total || 0) - itemDiscount);
        const taxAmount = (this.tax_enabled && taxPercent > 0)
          ? Number((taxableBase * taxPercent / 100).toFixed(2))
          : 0;

        it.itemDiscount = itemDiscount;
        it.taxAmount = taxAmount;
        it.totalWithTax = Number((taxableBase + taxAmount).toFixed(2));
        accumulatedTax += taxAmount;
      });

      this.total_tax = Number(accumulatedTax.toFixed(2));
      // final total = subtotal - total discount + total tax + delivery fee
      this.total = Number(((this.subtotal - discountAmount) + this.total_tax + (this.delivery_fee || 0)).toFixed(2));
    }
  },
  watch: {
    langGetter() {
      this.lang = this.$store.getters['ModApps/Marketea/lang'];
    },
    setting: {
      handler(newVal) {
        this.taxesPercent = newVal.tax_enabled && newVal.tax_percent > 0 ? newVal.tax_percent : 0;
        this.tax_enabled = newVal.tax_enabled || false;
        this.calculateTotals();
      },
      deep: true
    },
    order: {
      handler() {
        this.calculateTotals();
      },
      deep: true
    }
  }
};
</script>


<style scoped>
.order-form { max-width: 900px; }
.order-form { position: relative; padding-bottom: 84px; }
.d-flex { display:flex; }
.gap-2 { gap: 8px; }

/* Ensure modal content fits viewport and scrolls internally */
.modal-full-height {
  max-height: calc(100vh - 80px);
  overflow: auto;
  display: flex;
  flex-direction: column;
}

/* Keep form content from growing beyond the scroll area */
.modal-full-height form { display: flex; flex-direction: column; gap: 8px; }
.modal-full-height .row { flex: 0 0 auto; }
.modal-full-height .mt-3 { margin-top: 12px; }

/* Notes editor specific sizing (only for this form) */
.order-notes-editor >>> .vue-editor .ql-container,
.order-notes-editor ::v-deep .vue-editor .ql-container {
  max-height: 150px;
  height: 150px;
  overflow: auto;
}

.order-notes-editor >>> .vue-editor .ql-editor,
.order-notes-editor ::v-deep .vue-editor .ql-editor {
  min-height: 150px;
  max-height: 150px;
  overflow: auto;
}

/* Fixed footer for form */
.order-form-footer {
  position: sticky;
  bottom: -15px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 10px 0px 10px;
  background: rgba(255,255,255,0.98);
  border-top: 1px solid #e6e6e6;
}
.order-form-footer .footer-left .btn { margin-right: 8px; }
.order-form-footer .footer-right {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
}
.order-form-footer .footer-total-label {min-width: 50px;text-align: left; font-size: 1.5rem;}
.order-form-footer .footer-total-amount { font-size: 1.5rem; text-align: right; margin-left: 8px; min-width: 200px;}

</style>
